<template>
  <div class="main" style="position: relative">
    <div id="select_wrap_wrap"></div>
    <showHide left="10px">
      <my-select
        @history="reHistory"
        @park="repark"
        @parkDuration="reParkDuration"
        @alarmData="reAlarmData"
        @showAlarmList="openAlarmList = true"
        :bigSmall="true"
      >
      </my-select>
    </showHide>
    <!-- <div id="nowData-wrap" v-if="isJiuPian">
      <now-data1
        :data="otherData"
        :curentPoint1="curentPoint1"
        @changeSpeed1="reChangeSpeed1"
        @parentFn1="rePlayStop1"
        @changeSlider1="reChangeSlider1"1
        ref="slider1"
      ></now-data1>
    </div> -->
    <div id="map-wrap" v-show="!isJiuPian">
      <my-map1
        ref="gmap"
        @curentPoint="reCurentPoint"
        :isNavg="true"
        type="car"
      ></my-map1>
    </div>

    <drag v-if="openListAll" @close="openListAll = false">
      <list-all
        @drawPoint="reDrawPoint"
        ref="listAll"
        slot-scope="{ mydata }"
        :height="mydata"
      ></list-all>
    </drag>
    <driver-modal
      ref="driver"
      :curentPoint="curentPoint"
      v-if="isDriver"
      v-show="!$store.state.isPrint"
    ></driver-modal>
    <Modal
      v-model="openAlarmList"
      title="报警列表"
      :z-index="250"
      :draggable="false"
      footer-hide
      width="1100"
    >
      <Table
        width="100%"
        :height="400"
        :columns="columns"
        :data="alarmData"
        no-data-text="暂无数据，可尝试先查询轨迹看看"
      >
        <template slot-scope="{ row, index }" slot="parkDuration">
          <Tooltip v-if="row.isPark" placement="left-start" theme="light">
            {{ row.parkDuration }}
            <div slot="content">
              <p>停车时长：{{ utils.minTime(row.parkDuration) }}</p>
              <p>开始停车：{{ row.startParkTime }}</p>
              <p>结束停车：{{ row.endParkTime }}</p>
            </div>
          </Tooltip>
          <span v-else>暂无</span>
        </template>
        <template slot-scope="{ row, index }" slot="direction">
          <Direction :direction="row.direction"></Direction>
        </template>
      </Table>
    </Modal>
    <showHide right="10px" v-if="$store.state.control" v-show="!isJiuPian">
      <now-data
        :data="otherData"
        :curentPoint="curentPoint"
        @changeSpeed="reChangeSpeed"
        @parentFn="rePlayStop"
        @changeSlider="reChangeSlider"
        @dark="reDark"
        @jiashi="reJiashi"
        ref="slider"
      ></now-data>
    </showHide>
    <showHide right="280px" v-if="false" v-show="workData.length > 0&&!isShowCollect">
      <works :workData="workData"></works>
    </showHide>
    <point-list @points="rePointList" ref="pointList"></point-list>
    <line-list @lines="reLineList" ref="lineList"></line-list>
    <fence-list @fences="reFenceList" ref="fenceList"></fence-list>
    <div id="locusTools">
      <ButtonGroup>
        <Button
          :type="isYun ? 'primary' : 'default'"
          icon="md-cloudy"
          @click="showHideYun"
          title="卫星云图"
        ></Button>
        <Button
          :type="isShowCollect ? 'primary' : 'default'"
          icon="md-trash"
          @click="showHideSiteCollect"
          :disabled="siteCollectData.length == 0"
          title="收集点"
        ></Button>
        <Button
          icon="ios-pulse"
          :disabled="workData.length == 0"
          :type="isWorkLine ? 'primary' : 'default'"
          @click="showHideLine"
          title="作业线路"
        ></Button>
        <Button
          icon="md-pin"
          @click="$refs.pointList.open()"
          title="标注点"
        ></Button>
        <Button
          icon="ios-disc"
          @click="$refs.fenceList.open()"
          title="围栏"
        ></Button>
        <Button
          icon="md-git-branch"
          @click="$refs.lineList.open()"
          title="线路规划"
        ></Button>

      </ButtonGroup>
    </div>
  </div>
</template>
<script>
import myMap1 from "../map/locusMap.vue";
import mySelect from "./select";
import nowData from "./nowData.vue";
import axios from "axios";
import drag from "./drag";
import listAll from "./listAll.vue";
import driverModal from "./driverModal";
import myLine from "../rule/line/smallMap.vue";
import locusDraw from "./locusDraw.vue";
import works from "./works.vue";
export default {
  name: "locus",
  components: {
    myMap1,
    mySelect,
    nowData,
    drag,
    listAll,
    driverModal,
    myLine,
    locusDraw,
    works,
  },
  data() {
    return {
      reObj: {},
      isPrint: false,
      otherData: [],
      curentPoint: 0,
      curentPoint1: 0,
      openList: false,
      openListAll: false,
      isDriver: false,
      openSaveLine: false,
      lineData: {},
      showPark: true,
      duration: 30,
      isJiuPian: false,
      isFisrtJiupian: false, //是否第一次纠偏
      showAlarm: false,
      alarmData: [],
      openAlarmList: false,
      columns: [
        {
          type: "index",
          tooltip: true,
          minWidth: 70,
          maxWidth: 90,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
          minWidth: 100,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "报警消息",
          key: "info",
          minWidth: 100,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "报警时间",
          key: "startTime",
          minWidth: 130,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "报警地点",
          key: "startAdd",
          minWidth: 300,
          maxWidth: 400,
          ellipsis: false,
        },
      ],
      openFence: false,
      openLine: false,
      openPoint: false,
      workData: [],
      isWorkLine: false,
      siteCollectData: [],
      isShowCollect: false,
      isYun: false,
    };
  },
  methods: {
    //接收到的速度改变
    reChangeSpeed(v) {
      this.$refs.gmap.reSpeed(v);
    },
    //拖动滑块后，接收传过来得值，去调用地图组件函数
    reChangeSlider(v) {
      this.$refs.gmap.reSlider(v);
    },
    //接收子组件的播放暂停
    rePlayStop(t) {
      this.$refs.gmap.play(t);
    },
    //接收地图组件轨迹播放到当前点，准备传给滑块
    reCurentPoint(t, length) {
      this.$refs.slider.changeCurentPoint(t, length);
      this.curentPoint = t;
    },
    //打印轨迹
    doPrint() {
      var bdhtml = window.document.body.innerHTML;
      this.isPrint = true;
      this.$store.state.isPrint = true;
      setTimeout(() => {
        window.print();
        // window.close(); //调用完打印之后记得关闭，否则会导致预览的时候为空页面
        this.isPrint = false;
        this.$store.state.isPrint = false;
        //location.reload();
        // window.document.body.innerHTML = bdhtml;//重新渲染没有被打印的html内容
      }, 100);
      //调用打印的窗口
    },
    getData(x) {
      this.isJiuPian = false;
      this.isFisrtJiupian = true;
      let params = {
        deviceNo: x.deviceNo,
        returnCoord: 2, //返回坐标系（1-WGS84，2-GCJ-02，3-BD-09）,可用值:1,2,3
        endTime: x.end.getTime(),
        startTime: x.start.getTime(),
        space:3000,
        directionDegree:10
      };
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.lbs + "/locus/getPlyLocus",
        data: params,
      }).then((res) => {
        console.log(res.data.data);
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.otherData = data;
        //如果有轨迹在播放，先销毁
        if (this.$store.state.carMsg.play != 1) {
          this.$refs.gmap.play(4);
          this.$store.state.carMsg.play = 1;
        }
        if (res.data.code == 200) {
          if (data.length >= 1) {
            var lnglat = [];
            for (const i in data) {
              lnglat.push([data[i].returnX, data[i].returnY]);
              data[i].tms = data[i].gpsTime / 1000;
              data[i].locateLng = data[i].returnX;
              data[i].locateLat = data[i].returnY;
              data[i].gpsTime1 = this.utils.time(data[i].gpsTime);
              data[i].reportTime = this.utils.time(data[i].reportTime);
              data[i].startParkTime = this.utils.time(data[i].startParkTime);
              data[i].endParkTime = this.utils.time(data[i].endParkTime);
              data[i].parkDuration1 = this.utils.duration(data[i].parkDuration);
              //console.log(data[i].directionDegree,data[i].deviceStatus,data[i].mileage);
            }
            
            this.$refs.gmap.loadUi(lnglat, data); //渲染轨迹
            if (this.showPark) {
              this.$refs.gmap.showpark(this.otherData, this.duration); //停车点
            }
            this.$store.state.control = true;
            this.getAlarmData();
          } else if (data.length == 0) {
            this.$Message.error("暂无轨迹");
            this.$refs.gmap.loadUi([], []); //清空轨迹
            this.$refs.gmap.showpark([], 0); //清空停车点
            this.$store.state.control = false;
          }
        } else {
          this.$Message.error(res.data.message);
        }
      });
    },
    //接收白天黑夜模式
    reDark() {
      this.$refs.gmap.dark();
    },
    //接收驾驶模式
    reJiashi(v) {
      this.isDriver = v;
      if (v) {
        setTimeout(() => {
          this.$refs.driver.setWidth(this.otherData);
        }, 500);
      }
    },
    //选择控件下的一排按钮
    reHistory(m) {
      this.reObj = m;
      console.log(m);
      switch (m.val) {
        case 0: //轨迹列表
          this.reset();
          this.getData(m);
          if (m.carTypeCateg == "洗扫类") {
            this.getWorkLine(m);
          } else if (m.carTypeCateg == "清运类") {
            this.getPaibanLine(m);
          }

          break;
        case 1: //轨迹列表
          this.openListAll = true;
          setTimeout(() => {
            this.$refs.listAll.getHistory(m);
          }, 200);
          break;
        case 2: //导出轨迹
          break;
        case 3: //原始数据
          this.openListAll = true;
          setTimeout(() => {
            this.$refs.listAll.getHistory(m);
          }, 200);
          break;
        case 4: //导出原始
          break;
        case 5: //导出原始
          this.openStoreLine();
          break;
      }
    },
    reDrawPoint(v) {
      this.$refs.gmap.drawPoint(v);
    },
    //打开保存轨迹
    openStoreLine() {
      if (this.otherData.length == 0) {
        this.$Message.warning({
          content: "请先查看轨迹，确认后再保存",
          duration: 4,
        });
        return;
      }
      this.openSaveLine = true;
      var arr = [];
      for (const i in this.otherData) {
        var obj = {
          gcj02x: this.otherData[i].gcj02x,
          gcj02y: this.otherData[i].gcj02y,
        };
        arr.push(obj);
      }

      this.lineData = {
        addUpdateBlind: 0,
        distance: 5,
        duration: 1,
        name: "",
        pointList: arr,
        routeId: null,
      };
    },
    //停车点
    repark(v) {
      this.showpark = v;
      if (v) {
        this.$refs.gmap.showpark(this.otherData, this.duration); //停车点
      } else {
        this.$refs.gmap.showpark([], this.duration); //停车点
      }
    },
    reParkDuration(v) {
      this.duration = v;
      this.$refs.gmap.showpark(this.otherData, this.duration); //停车点
    },
    changeJiu() {
      this.isJiuPian = !this.isJiuPian;
      if (this.isJiuPian && this.isFisrtJiupian) {
        this.$refs.jiupian.jiupian(this.otherData); //渲染纠偏轨迹
      }
      this.isFisrtJiupian = false;
    },
    getAlarmData() {
      return;
      var x = this.reObj;
      let params = {
        alarmTypeIdList: [],
        deviceNoList: [x.deviceNo],
        endTime: x.end.getTime(),
        startTime: x.start.getTime(),
      };
      axios({
        method: "post",
        url: axios.serverWeb + "/alarmInfo/list",
        data: params,
      }).then((res) => {
        var data = res.data.data.dataList;
        for (const i in data) {
          data[i].startTime = this.utils.time(data[i].startTime);
        }
        this.alarmData = data;
        if (this.showAlarm) {
          this.$refs.gmap.showAlarm(this.alarmData);
        } else {
          this.$refs.gmap.showAlarm([]);
        }
      });
    },
    reAlarmData(v) {
      this.showAlarm = v;
      if (v) {
        this.$refs.gmap.showAlarm(this.alarmData);
      } else {
        this.$refs.gmap.showAlarm([]);
      }
    },
    //加载作业线路
    getWorkLine(x) {
      //this.isJiuPian = false;
      //this.isFisrtJiupian = true;
      let params = {
        deviceNo: x.deviceNo,
        endDate: x.end.getTime(),
        startDate: x.start.getTime(),
      };
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.mwm + "/schedule/carLine",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;

        for (const i in data) {
          data[i].coordList = data[i].pointList[0];
        }
        console.log(data);
        this.workData = data;
        this.showHideLine();
      });
    },
    showHideLine() {
      this.isWorkLine = !this.isWorkLine;
      if (this.isWorkLine) {
        //this.$refs.gmap.showWorksLines(this.workData);
        this.$refs.gmap.showLines(this.workData);
      } else {
        //this.$refs.gmap.showWorksLines([]);
        this.$refs.gmap.showLines([]);
      }
    },
    reFenceList(v) {
      this.$refs.gmap.showFences(v);
    },
    reLineList(v) {
      this.$refs.gmap.showLines(v);
    },
    rePointList(v) {
      this.$refs.gmap.showPoints(v);
    },
    getSiteCollectList(row) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.gc + "/siteCollect/list",
        data: { routeId: row.lineId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        this.siteCollectData = data;
        this.showHideSiteCollect();
      });
    },
    showHideSiteCollect() {
      this.isShowCollect = !this.isShowCollect;
      if (this.isShowCollect) {
        this.$refs.gmap.showLjt(this.siteCollectData);
      } else {
        this.$refs.gmap.showLjt([]);
      }
    },
    //用车牌号去获取绑定线路
    getPaibanLine(row) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.gc + "/schedule/list",
        data: { keyWork: row.carNo },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        console.log(data);
        this.getSiteCollectList(data[0]);
        this.getQingyunLine(data[0]);
        //this.$refs.gmap.showLjt(this.siteCollectData);
      });
    },
    getQingyunLine(row) {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/route/item",
        data: { id: row.lineId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.workData = [data];
        this.showHideLine();
      });
    },

    reset() {
      this.openListAll = false;
      this.siteCollectData = [];
      this.workData = [];
      this.isWorkLine = false;
      this.isShowCollect = false;
      this.$refs.gmap.showLjt([]);
      this.$refs.gmap.showLines([]);
    },
    showHideYun() {
      this.isYun = !this.isYun;
      this.$refs.gmap.reYun(this.isYun);
    },
  },
  mounted() {
    this.$store.state.t = 2;
    /* document.getElementById('dayin').onclick=function(){
      alert(123)
    } */
    // console.log(this.$store.t);
  },
};
</script>
<style lang="">
/*去除百度地图版权*/
.anchorBL {
  display: none;
}
#select_wrap_wrap {
  position: absolute;
  z-index: 2;
  min-width: 40px;
  margin-top: 10px;
  margin-left: 10px;
}
#locusTools {
  position: absolute;
  bottom: 10px;
  z-index: 2;
  margin: 0 auto;
  left: 50%;
  margin-left: -100px;
  border: solid 1px #ccc;
}

.print {
  width: 100%;
  height: 100%;
  position: absolute !important;
  left: 0;
  top: 0;
  z-index: 12345;
  background: #333;
  padding-top: 0 !important;
}
#map-wrap {
  width: 100%;
  height: 100%;
  background: #ccc;
}
#jpbtn {
  position: absolute;
  z-index: 2;
  bottom: 15px;
  right: 15px;
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/index.vue